import { ReactElement, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Header, Footer, Loader, ScrollToTop } from '@components/common';
import { convertPathNameToTitle } from '@helper/utils';
// import { endUserPaths } from '@components/members';
import { CheckServiceWorkerUpdates } from './checkServiceWorkerUpdates';
import { useRouteStoreReset } from '@hooks/useRouteStoreReset';
import { useRouteHandler } from '../authGuard';
import '@assets/styles/app.scss';
import { useOverlayStore } from '@store/useOverlaySrote';

export const RootLayout = (): ReactElement => {
	const { pathname } = useLocation();
	const { isAuthenticated, permissionAndSessionCheck } = useRouteHandler();
	const isOverlayVisible = useOverlayStore((state) => state.isSidebarOpen || state.isFilterOpen || state.isSortOpen);
	const isFilterOrSortOpen = useOverlayStore((state) => state.isFilterOpen || state.isSortOpen);
	const closeOverlay = useOverlayStore((state) => state.closeOverlay);

	const getTitleFromPathname = (pathname: string): string => {
		// if (endUserPaths.includes(pathname)) {
		// 	return 'End Users';
		// }
		return convertPathNameToTitle(pathname);
	};

	useRouteStoreReset(pathname);

	if (!isAuthenticated() && pathname !== '/login') {
		return (
			<Suspense fallback={<Loader />}>
				<Navigate to="/login" replace />
			</Suspense>
		);
	}

	return (
		<>
			<ScrollToTop />
			{isAuthenticated() && <Header menuHeading={getTitleFromPathname(pathname)} />}
			<main>
				<Suspense fallback={<Loader />}>{permissionAndSessionCheck()}</Suspense>
			</main>
			<button
				id="overlay"
				type="button"
				className={`overlay ${isOverlayVisible ? 'show' : ''} ${isFilterOrSortOpen ? 'overlay-filter' : ''}`}
				onClick={closeOverlay}
				onKeyDown={(e) => (e.key === 'Escape' || e.key === 'Enter') && closeOverlay()}
				aria-label="Close overlay"
			/>
			{isAuthenticated() && <Footer />}
			<CheckServiceWorkerUpdates />
		</>
	);
};
